module.exports = __webpack_public_path__ + "img/img23.c30f268f.png";